import { render, staticRenderFns } from "./AuthCreateUser.vue?vue&type=template&id=773f3e74&"
import script from "./AuthCreateUser.vue?vue&type=script&lang=js&"
export * from "./AuthCreateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports